import React, { createContext, ReactNode, useContext } from 'react';
import { useLocation } from 'react-router-dom';

export enum PageType {
  STATIC = 'static',
  FORM = 'form',
}

interface PageTypeContextType {
  pageType: PageType;
  isStaticPage: boolean;
  staticRoutes: string[];
}

const PageTypeContext = createContext<PageTypeContextType>({
  pageType: PageType.FORM,
  isStaticPage: false,
  staticRoutes: [],
});

interface PageTypeProviderProps {
  children: ReactNode;
  staticRoutes?: string[];
}

export const PageTypeProvider: React.FC<PageTypeProviderProps> = ({
  children,
  staticRoutes = [],
}) => {
  const location = useLocation();

  // Check if current path matches any static route
  const isStaticPage = staticRoutes.some(
    (route) =>
      location.pathname.includes(route) || location.pathname.endsWith(route)
  );

  const pageType = isStaticPage ? PageType.STATIC : PageType.FORM;

  return (
    <PageTypeContext.Provider value={{ pageType, isStaticPage, staticRoutes }}>
      {children}
    </PageTypeContext.Provider>
  );
};

export const usePageType = () => useContext(PageTypeContext);

export default PageTypeContext;
